import { render, staticRenderFns } from "./stripePay.vue?vue&type=template&id=1d445e82&scoped=true"
import script from "./stripePay.vue?vue&type=script&lang=js"
export * from "./stripePay.vue?vue&type=script&lang=js"
import style0 from "./stripePay.vue?vue&type=style&index=0&id=1d445e82&lang=less"
import style1 from "./stripePay.vue?vue&type=style&index=1&id=1d445e82&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d445e82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d445e82')) {
      api.createRecord('1d445e82', component.options)
    } else {
      api.reload('1d445e82', component.options)
    }
    module.hot.accept("./stripePay.vue?vue&type=template&id=1d445e82&scoped=true", function () {
      api.rerender('1d445e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setting/pricing/stripePay.vue"
export default component.exports